import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useWorkerGroupsQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectEnvironmentGroup: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: allWorkerGroups, isLoading: isLoadingWorkersGroups } = useWorkerGroupsQuery(
    String(pathParameters.workspace_id),
  );

  const environmentGroupItems = useMemo(
    () =>
      Object.entries(allWorkerGroups || []).map(([id, environmentGroup]) => ({
        label: environmentGroup.name,
        value: id,
      })),
    [allWorkerGroups],
  );

  return (
    <ApiHelperSelectInput
      label={t('workerApi.chooseWorkerGroup')}
      items={environmentGroupItems}
      onChange={(value) => setValue('worker_group_id', value)}
      loading={isLoadingWorkersGroups}
      value={value}
      noItemsFound={t('workerApi.noWorkerGroups')}
      {...props}
    />
  );
};
